import styled from 'styled-components';
import colors from 'constants/colors';

export const SideBarItemContainer = styled.div`
  cursor: pointer;
  height: ${(props) => props.rowHeight ? props.rowHeight + 'px' : '32px'};
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  background-color: ${(props) => props.warning? colors.black5: null};
  color: ${(props) => props.warning? colors.red: colors.lightBlue};
  padding-right: 20px;

  .warningCover {
    position: absolute;
    height: 32px;
    width: 100%;
    left: 100px;
    right: 0;
    background-color: ${colors.silver};
    z-index: 5;
  }
`;

export const TimelineSubHeaderContainer = styled.div`
  position: fixed;
  top: 50px;
  z-index: 500;
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: ${colors.black1};
  color: ${colors.white};
  padding-left: 10px;

  .title {
    font-size: 12px;
    letter-spacing: 1px;
    font-weight: 600;
    color: ${colors.silver};
    margin-right: 5px;
  }

  .contentContainer {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 10px;

    .dateSection {
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 170px;
    }
  }
`;

export const ItemRendererContainer = styled.div`
  width: 100%;
  min-width: 0;
  height: 24px;
  line-height: 24px;
  display: block;
  white-space: nowrap;
  text-align: center;
  overflow: hidden;
  text-overflow : ellipsis;
  contain: content; /* Modern containment */
  padding: 0 1.5px;
  font-size: 14px;
  font-weight: bold;
  color: ${colors.black1};
`;

export const GroupLabelContainer = styled.div`
  position: absolute;
  top: ${(props) => props.top ? `${props.top}px` :'0'};;
  background-color: ${colors.black1};
  border-left: 1px solid ${colors.white};
  width: 30px;
  height: ${(props) => props.height ? `${props.height}px` :'32px'};
  display: flex;
  writing-mode: vertical-rl; 
  transform: rotate(180deg);
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: ${colors.white};
  z-index: 100;
`;

export const DividingLine = styled.div`
  position: absolute;
  top: ${(props) => props.top ? `${props.top}px` :'0'};;
  height: 1px;
  width: 100%;
  background-color: ${colors.white};
`;

export const BookingTimelineContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${colors.black1};
  padding-bottom: 10px;
  margin-top: ${props => props.fixedHeader? '100px': null};

  @media only screen and (min-width: 767px) and (max-width: 1200px) {
    padding-bottom: 70px;
  }

  @media only screen and (max-width: 767px) {
    padding-bottom: 55px;
  }

  .rct-header-root {
    border-top: 1px solid ${colors.dimGrey};
    & > :nth-child(1) {
      border-right: 1px solid ${colors.white};
    }
    ${props => props.fixedHeader? `
      position: fixed;
      top: 100px;
      z-index: 1000;
    `: null};
  }

  ${props => props.fixedHeader? `
    .rct-outer {
      margin-top: 151.6px;
    }

    .rct-header-root {
      position: fixed;
      top: 100px;
      z-index: 1000;
      border-top: 1px solid ${colors.dimGrey};
      & > :nth-child(1) {
        border-right: 1px solid ${colors.white};
      }
    }
  `: null};

  .timelineHeader {
    border-top: none;
    border-bottom: none;
    div {
      border-top: none !important;
      border-bottom: none !important;
      border-left: none !important;
    }
  }

  .react-calendar-timeline .rct-calendar-header {
    border: none;
  }

  .react-calendar-timeline .er-root {
    background: none;
  }

  .react-calendar-timeline .rct-sidebar {
    position: static;
  }

  .react-calendar-timeline .rct-horizontal-lines .rct-hl-even, 
  .react-calendar-timeline .rct-horizontal-lines .rct-hl-odd,
  .react-calendar-timeline .rct-sidebar .rct-sidebar-row {
    border-bottom: 1px solid ${colors.charcoal};
  }

  .react-calendar-timeline .rct-vertical-lines .rct-vl {
    border-left: 1px solid ${colors.charcoal};
  }

  .react-calendar-timeline .rct-horizontal-lines .rct-hl-even,
  .react-calendar-timeline .rct-sidebar .rct-sidebar-row.rct-sidebar-row-even {
    background-color: ${colors.black1};
  }

  .react-calendar-timeline .rct-horizontal-lines .rct-hl-odd,
  .react-calendar-timeline .rct-sidebar .rct-sidebar-row.rct-sidebar-row-odd {
    background-color: ${colors.black5};
  }

  .react-calendar-timeline .rct-vertical-lines .rct-vl.rct-day-6,
  .react-calendar-timeline .rct-vertical-lines .rct-vl.rct-day-0 {
    background: none;
  }

  .rct-item {
    /* border: none !important; */
    .rct-item-content {
      width: 100%;
      height: auto !important;
    }
  }

`;

export const TimelineHeaderContainer = styled.div`
  .today {
    color: ${colors.black1} !important;
    background-color: ${colors.green} !important;
    border-right:1px solid ${colors.green} !important;
  }
`;
